import Vue from 'vue';
import VueRouter from 'vue-router';
import Vuex from 'vuex';
import VuexCache from 'vuex-cache';
import axios from 'axios';
import VueAxios from 'vue-axios';
import bootstrap from 'bootstrap'; // eslint-disable-line no-unused-vars
import config from './config';
import storeConfig from './store';
import './css/styles.css';

Vue.config.devtools=false;
Vue.config.debug=false;
Vue.config.silent=true;
Vue.config.productionTip=false;

// main app vue
import app from './App.vue';

Vue.use(VueAxios, axios);
Vue.use(Vuex);
Vue.use(VuexCache);
Vue.use(VueRouter);

// global config vars defined in config.js
Object.defineProperty(Vue.prototype, '$config', {
  get () {
    return this.$root.config;
  }
});

// configure state management
const store = new Vuex.Store(storeConfig);

// configure router
const router = new VueRouter({
  routes: config.routes,
  linkActiveClass: 'active'
});

// main app
new Vue({
  el: '#app',
  render: h => h(app),
  router,
  store,
  
  // global data
  data: {
    config: config
  },
  created() {
    /* normally this data would be loaded per component,
       but we load it here because there is no persistence 
       see store.js for more details   
    */
    //this.$store.dispatch('LOAD_POSTS');
  },
  computed: {
    posts() {
      //return this.$store.state.posts;
      return [];
    }
  },
  mounted() {
    var self = this;
    this.$router.afterEach(function (transition) {
      self.$nextTick(() => {
          // scroll to top after each route change
          var $main = document.querySelector('.main');
          if (transition.hash) {
            var $ele = document.querySelector(transition.hash);
            if ($ele) {
              $ele.scrollIntoView();
            }
          }
          else if ($main) {
            $main.scrollTop = 0;
          }
          else {
            window.scrollTo(0,0);
          }
      });
    });
  }
});
